<ion-grid class="ai-chat-analytics">
  <ion-row class="ai-chat-analytics__header">
    <ion-col class="ai-chat-analytics__header-left">
      <div class="ai-chat-analytics__title">
        <ion-img src="/assets/img/ai-analytics-logo.svg" alt="AI Analytics"></ion-img>
        <span> {{ 'aiAnalytics.ChatbotAi' | translate }} </span>
      </div>

      <ion-button
        fill="clear"
        class="ai-chat-analytics__new-chat-btn"
        (click)="openCreateNewTabConfirmationModel('USER_ACTION')"
        [disabled]="isNewChatBtnDisabled()"
      >
        <ion-img src="/assets/img/new-chat.svg" alt="New Chat"></ion-img>
        <span> {{ 'aiAnalytics.NewChat' | translate }} </span>
      </ion-button>
    </ion-col>

    <ion-col class="ai-chat-analytics__header-right">
      <ion-button fill="clear" (click)="closeModal()">
        <ion-img src="/assets/img/close.svg" alt="Close"></ion-img>
      </ion-button>
    </ion-col>
  </ion-row>

  <ion-row class="ai-chat-analytics__body">
    <ion-col class="ai-chat-analytics__body-content">
      <monorepo-chat-ui
        (chatUiUpdateEvent)="chatUiUpdateEvent($event)"
        [zChatUiModel]="chatUiModel()"
        [quickQuestions]="quickQuestions"
        [initialUiText]="{
          header: 'aiAnalytics.welcomeHeader',
          content: 'aiAnalytics.welcomeContent'
        }"
      ></monorepo-chat-ui>
    </ion-col>
  </ion-row>
</ion-grid>
